<script setup>
import InlineSvg from 'vue-inline-svg'
import app from '@/main.js'
import { inject, ref } from 'vue'
import { userBlock } from '@/api/api.js'
import ErrorMessage from '@/components/Functional/ErrorMessage.vue'

const props = defineProps({
  userId: {
    type: String,
    required: true
  },
  callback: {
    type: Function,
    required: false,
    default: null
  }
})

const close = inject('close')

const errorMessage = ref(null)
const loading = ref(false)

async function report () {
  if (loading.value) {
    return
  }

  try {
    await userBlock(props.userId)

    errorMessage.value = null
    close()

    if (props.callback) {
      props.callback()
    }
  } catch (error) {
    errorMessage.value = error.message || 'An error occurred while sending the report.'
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <div
    ref="el"
    class="bg-white p-6 shadow-lg w-full relative rounded-xl h-max self-center"
    @click.stop>
    <div class="flex items-center justify-between mb-3">
      <h2 class="text-lg font-bold text-gray-900">
        {{ app.$i18n.t('creator.block.block_this_creator') }}
      </h2>

      <button type="button" @click="close">
        <InlineSvg
          class="h-4 w-4"
          :src="require('@/assets/fontawesome/regular/xmark.svg')"/>
      </button>
    </div>

    <ErrorMessage
      v-if="errorMessage"
      :message="errorMessage"/>

    <div>
      <button
        type="button"
        class="mb-3 mt-5 block px-6 py-3 w-full font-semibold text-white rounded bg-brand hover:bg-brand-hover"
        @click="report">
        {{ app.$i18n.t('common.yes') }}
      </button>

      <button
        type="button"
        class=" block px-6 py-3 w-full font-semibold rounded text-gray-500 hover:bg-gray-100 disabled:hover:bg-white"
        @click="close">
        {{ app.$i18n.t('common.cancel') }}
      </button>
    </div>
  </div>
</template>